import React from 'react'
import Img_feedback from 'assets/icon/Img_feedback.png';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Trans, Translation } from 'react-i18next';

const Section_6 = () => {

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1
                }
            }
        ]

    };


    return (
        <section className='section section_6' style={{display: 'none'}}>
            <div className='wrapper_box_feedback'>
                <div className='container'>
                    <div className='slide_box_feedback'>
                        <div className='wrap_box_style_cover'>
                            <div className='head'>
                                <h2><Translation>
                                    {
                                        (t, { i18n }) => t('content.Customers')

                                    }
                                </Translation></h2>
                            </div>
                        </div>
                        <AnimationOnScroll
                            animateIn="animate__fadeInLeft"
                            offset={0}
                            duration={2}
                        >
                            <div className='list_slider'>
                                <Slider {...settings}>

                                    <div className='item'>
                                        <div className='item_slider'>
                                            <div className='image'>
                                                <img src={Img_feedback} alt='face' />
                                            </div>
                                            <div className='descreptions'>
                                                <p>“<Translation>
                                                    {
                                                        (t, { i18n }) => t('content.Ipsum')

                                                    }
                                                </Translation> ”</p>
                                            </div>
                                            <div className='job_custommer'>
                                                <span><Translation>
                                                    {
                                                        (t, { i18n }) => t('content.Job')

                                                    }
                                                </Translation></span>
                                                <h4><Translation>
                                                    {
                                                        (t, { i18n }) => t('content.Name')

                                                    }
                                                </Translation></h4>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='item'>
                                        <div className='item_slider'>
                                            <div className='image'>
                                                <img src={Img_feedback} alt='face' />
                                            </div>
                                            <div className='descreptions'>
                                                <p>“<Translation>
                                                    {
                                                        (t, { i18n }) => t('content.Ipsum')

                                                    }
                                                </Translation> ”</p>
                                            </div>
                                            <div className='job_custommer'>
                                                <span><Translation>
                                                    {
                                                        (t, { i18n }) => t('content.Job')

                                                    }
                                                </Translation></span>
                                                <h4><Translation>
                                                    {
                                                        (t, { i18n }) => t('content.Name')

                                                    }
                                                </Translation></h4>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='item'>
                                        <div className='item_slider'>
                                            <div className='image'>
                                                <img src={Img_feedback} alt='face' />
                                            </div>
                                            <div className='descreptions'>
                                                <p>“<Translation>
                                                    {
                                                        (t, { i18n }) => t('content.Ipsum')

                                                    }
                                                </Translation> ”</p>
                                            </div>
                                            <div className='job_custommer'>
                                                <span><Translation>
                                                    {
                                                        (t, { i18n }) => t('content.Job')

                                                    }
                                                </Translation></span>
                                                <h4><Translation>
                                                    {
                                                        (t, { i18n }) => t('content.Name')

                                                    }
                                                </Translation></h4>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='item'>
                                        <div className='item_slider'>
                                            <div className='image'>
                                                <img src={Img_feedback} alt='face' />
                                            </div>
                                            <div className='descreptions'>
                                                <p>“<Translation>
                                                    {
                                                        (t, { i18n }) => t('content.Ipsum')

                                                    }
                                                </Translation> ”</p>
                                            </div>
                                            <div className='job_custommer'>
                                                <span><Translation>
                                                    {
                                                        (t, { i18n }) => t('content.Job')

                                                    }
                                                </Translation></span>
                                                <h4><Translation>
                                                    {
                                                        (t, { i18n }) => t('content.Name')

                                                    }
                                                </Translation></h4>
                                            </div>
                                        </div>
                                    </div>

                                </Slider>
                            </div>
                        </AnimationOnScroll>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Section_6